import * as React from 'react';
import { Facet } from '@elastic/react-search-ui';
import { parseDisplayOrder, useClickOutside } from '../../helper';
import OrderedCheckboxList from './OrderedCheckboxList';
import classnames from "classnames";

export default function OpenSearchFacet(props) {
  const {field, label, show, hidden = false, order} = props;
  const customOrder = parseDisplayOrder(order);

  const [isOpen, setIsOpen] = React.useState(false);

  const rootEl = React.useRef(null);

  const handleClickOutside = () => {
    if (isOpen) {
      setIsOpen(false);
    }
  };

  useClickOutside(rootEl, handleClickOutside);

  const handleClick = () => {
    setIsOpen(prev => !prev);
  }

  const css = {
    root: classnames({
      'facet': true,
      'facet--dropdown': true,
      'facet--expanded': isOpen,
      'facet--hidden': hidden,
    }),
  }

  return (
    <div className={css.root} ref={rootEl}>
      <button className='facet__button' onClick={handleClick}>
        {label}
      </button>
      <div className='facet__items'>
        <div className='facet__scroll'>
          <Facet field={field} show={show} label={label} filterType='any'
            view={customOrder.length > 0
              ? viewProps => <OrderedCheckboxList {...viewProps} customOrder={customOrder}/>
              : undefined}/>
        </div>
      </div>
    </div>
  )
}
